import React, { useState, useEffect } from "react";
import "../App.css";
import ImageSlider from "../components/ImageSlider"; // Import the updated ImageSlider component
import InstaEmbed from "../components/InstaEmbed";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        // Better handling of local & live backend linking
        const apiUrl =
          process.env.NODE_ENV === "development"
            ? "http://127.0.0.1:8000/get_data"
            : "https://last-resort-api.azurewebsites.net/get_data";

        // Get events as json
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ query: "get_events" }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setEvents(data);
      } catch (err) {
        console.error("Failed to fetch events:", err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <section id="news" className="page-section">
      {isLoading ? (
        <div>Loading events...</div>
      ) : error ? (
        <div>Error loading events: {error}</div> // TODO (kyle): Display something better when events fetch fails
      ) : (
        <>
          <div className="events-container">
            <ImageSlider events={events} />
          </div>
          <div className="ig-container">
            <InstaEmbed profileId={""} accessToken={""} />
          </div>
        </>
      )}
    </section>
  );
};

export default Events;
